export const categories = [
  {
    id: 'antipasti',
    name: 'Antipasti',
    icon: 'fa-cheese',
    description: 'Begin your culinary journey with our selection of traditional Italian appetizers, featuring the finest local ingredients and time-honored recipes passed down through generations.'
  },
  {
    id: 'pasta',
    name: 'Pasta',
    icon: 'fa-utensils',
    description: 'Handmade pasta prepared fresh daily using traditional techniques and the finest durum wheat from Puglia.'
  },
  {
    id: 'pizza',
    name: 'Pizza',
    icon: 'fa-pizza-slice',
    description: 'Wood-fired pizzas made with our signature sourdough and San Marzano tomatoes.'
  },
  {
    id: 'secondi',
    name: 'Secondi',
    icon: 'fa-drumstick-bite',
    description: 'Main courses featuring premium meats and fresh seafood.'
  },
  {
    id: 'insalate',
    name: 'Insalate',
    icon: 'fa-leaf',
    description: 'Fresh salads with seasonal ingredients.'
  },
  {
    id: 'contorni',
    name: 'Contorni',
    icon: 'fa-bread-slice',
    description: 'Traditional Italian side dishes.'
  },
  {
    id: 'dolci',
    name: 'Dolci',
    icon: 'fa-ice-cream',
    description: 'House-made desserts to complete your meal.'
  },
  {
    id: 'bevande',
    name: 'Bevande',
    icon: 'fa-wine-glass-alt',
    description: 'Curated selection of wines, cocktails, and beverages.'
  }
];

export const menuItems = {
  antipasti: [
    {
      id: 'bruschetta',
      name: 'Bruschetta della Casa',
      description: 'Toasted artisan bread topped with ripe San Marzano tomatoes, fresh basil, garlic, and drizzled with extra virgin olive oil',
      price: 'PLN 8.50',
      image: 'https://images.unsplash.com/photo-1529042410759-befb1204b468?w=300&h=200&fit=crop',
      alt: 'Bruschetta with fresh tomatoes, basil, garlic, and extra virgin olive oil',
      badge: { type: 'chef-choice', text: "Chef's Choice" },
      dietaryInfo: [{ type: 'vegetarian', icon: 'fa-leaf' }]
    },
    {
      id: 'burrata',
      name: 'Burrata con Pomodorini',
      description: 'Creamy burrata cheese served with heirloom cherry tomatoes, basil, and 12-year aged balsamic vinegar.',
      price: 'PLN 14.95',
      image: 'https://images.unsplash.com/photo-1544982503-9f984c14501a?w=300&h=200&fit=crop',
      alt: 'Creamy burrata cheese with cherry tomatoes',
      dietaryInfo: [
        { type: 'vegetarian', icon: 'fa-leaf' },
        { type: 'gluten-free', icon: 'fa-wheat-awn-circle-exclamation' }
      ]
    },
    {
      id: 'carpaccio',
      name: 'Carpaccio di Manzo',
      description: 'Thinly sliced raw beef tenderloin with arugula, capers, shaved Parmigiano-Reggiano, and white truffle oil.',
      price: 'PLN 16.50',
      image: 'https://images.unsplash.com/photo-1551024709-8f23befc6f87?w=300&h=200&fit=crop',
      alt: 'Thinly sliced raw beef with arugula, capers, and parmesan',
      badge: { type: 'new-item', text: 'New' }
    },
    {
      id: 'fritto-misto',
      name: 'Fritto Misto di Mare',
      description: 'Lightly fried calamari, shrimp, and seasonal fish served with zucchini, lemon, and spicy aioli.',
      price: 'PLN 18.50',
      image: 'https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=300&h=200&fit=crop',
      alt: 'Mixed fried seafood with lemon',
      dietaryInfo: [{ type: 'spicy', icon: 'fa-pepper-hot' }]
    }
  ],
  pasta: [
    {
      id: 'carbonara',
      name: 'Spaghetti alla Carbonara',
      description: 'Traditional Roman pasta with guanciale, pecorino Romano, and farm-fresh eggs.',
      price: 'PLN 12.50',
      image: 'https://images.unsplash.com/photo-1621996346565-e3dbc353d946?w=300&h=200&fit=crop',
      alt: 'Spaghetti carbonara'
    },
    {
      id: 'cacio-pepe',
      name: 'Cacio e Pepe',
      description: 'Simple perfection: tonnarelli pasta with Pecorino Romano cheese and freshly cracked black pepper.',
      price: 'PLN 11.00',
      image: 'https://images.unsplash.com/photo-1551892589-865f69869476?w=300&h=200&fit=crop',
      alt: 'Cacio e pepe pasta'
    }
  ],
  pizza: [
    {
      id: 'margherita',
      name: 'Pizza Margherita',
      description: 'Classic pizza with San Marzano tomatoes, mozzarella di bufala, and fresh basil.',
      price: 'PLN 11.00',
      image: 'https://images.unsplash.com/photo-1513104890138-7c749659a591?w=300&h=200&fit=crop',
      alt: 'Margherita pizza',
      dietaryInfo: [{ type: 'vegetarian', icon: 'fa-leaf' }]
    },
    {
      id: 'prosciutto',
      name: 'Pizza Prosciutto e Funghi',
      description: 'Classic combination of San Daniele prosciutto, fresh mushrooms, and mozzarella.',
      price: 'PLN 15.50',
      image: 'https://images.unsplash.com/photo-1574071318508-1cdbab80d002?w=300&h=200&fit=crop',
      alt: 'Prosciutto and mushroom pizza'
    }
  ],
  secondi: [],
  insalate: [],
  contorni: [],
  dolci: [],
  bevande: []
};